import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';
import { DocumentType } from '../../enums/document-type';

export const createNewBatchAsync = (name, note, assignToUserId) =>
  axios.post('/fulfillmentPlanSet', {
    name,
    note,
    assignToUserId,
  });

export const createBatch = (name, note, assignToUserId) => {
  const request = createNewBatchAsync(name, note, assignToUserId).then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const addSalesOrdersToBatch = (fulfillmentPlanSetId, salesOrderIds, filter) => {
  const put = axios.put(`/fulfillmentPlanSet/${fulfillmentPlanSetId}/addSalesOrders`, {
    salesOrderIds,
    filter,
  });
  const resp$ = from(put);
  return resp$;
};

export const saveBatch = (fulfillmentPlanSetId, name, note, assignToUserId) => {
  const request = axios
    .put(`/fulfillmentPlanSet/${fulfillmentPlanSetId}`, {
      name,
      note,
      assignToUserId,
    })
    .then((response) => {
      return get(response, 'data', undefined);
    });

  const data$ = from(request);
  return data$;
};

export const saveBatchAsync = (fulfillmentPlanSetId, name, note, assignToUserId) =>
  axios.put(`/fulfillmentPlanSet/${fulfillmentPlanSetId}`, {
    name,
    note,
    assignToUserId,
  });

export const validateLabelBatchCancel = (labelBatchIds = []) => {
  const post = axios
    .post('label/batch/validateLabelBatchCancel', {
      labelBatchIds,
    })
    .then((response) => {
      return response.data;
    });

  const post$ = from(post);
  return post$;
};

export const cancelBatch = (labelBatchIds = []) => {
  const post = axios.post('label/batch/cancelLabelBatch', labelBatchIds).then((response) => {
    return response.data;
  });

  const post$ = from(post);
  return post$;
};

export const addFulfillmentPlansToBatchAsync = (fulfillmentPlanSetId, fulfillmentPlanIds, filter) =>
  axios.put(`/fulfillmentPlanSet/${fulfillmentPlanSetId}/addFulfillmentPlans`, {
    fulfillmentPlanIds,
    filter,
  });

export const addFulfillmentPlansToBatch = (fulfillmentPlanSetId, fulfillmentPlanIds, filter) => {
  const put = addFulfillmentPlansToBatchAsync(fulfillmentPlanSetId, fulfillmentPlanIds, filter);
  const resp$ = from(put);
  return resp$;
};

export const canPurchaseLabelsForBatch = (fulfillmentPlanSetIds = []) => {
  const post = axios.post('/label/canPurchaseForFulfillmentPlanSets', fulfillmentPlanSetIds).then((response) => {
    return get(response, 'data');
  });

  const post$ = from(post);
  return post$;
};

export const checkLabelPrintedStatus = (fulfillmentPlanSetId) => {
  const post = axios.post('/label/status/byFulfillmentPlan', { fulfillmentPlanSetId }).then((response) => response.data);

  const post$ = from(post);
  return post$;
};

export const checkPackingSlipPrintedStatus = (fulfillmentPlanSetId) => {
  const post = axios.post('packingslip/LoadStatus', { fulfillmentPlanSetId }).then((response) => response.data);

  const post$ = from(post);
  return post$;
};

export const checkDoesBatchHaveOtherForms = (fulfillmentPlanSetId) => {
  return axios.get(`${DocumentType.BatchOtherForms.apiDownloadPath}${fulfillmentPlanSetId}`);
};

export const markFulfillmentPlanSetsAsPrinted = (fulfillmentPlanSetIds, isPrinted) => {
  return axios
    .post('/label/batch/markAsPrinted', {
      labelBatchIds: fulfillmentPlanSetIds,
      isPrinted,
    })
    .then((response) => response?.data);
};
